import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class CardModal extends Component {
  state = {
    showPopup: false
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);

    setTimeout(() => {
      this.setState({ showPopup: true })
    }, 100)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  escFunction = (event) => {
    // event.preventDefault()
    // event.stopPropagation()

    if (event.keyCode === 27) {
      this.onCancel()
    }
  }

  onCancel = () => {
    const { onClose } = this.props
    this.setState({ showPopup: false }, () => {
      setTimeout(() => {
        onClose()
      }, 100)
    })
  }

  render() {
    const { secondaryBody, classNames } = this.props;

    const wrapperClass = classnames('card_modal', {
      'modal_visible': this.state.showPopup
    });

    return (
      <>
        <div className={wrapperClass}>
          <div className={`${classNames} modal__frame`}>
            <div className={`modal__title ${this.props.titleClass}`}>{this.props.title}</div>
            <div className="flow-modules__subtitle">{this.props.subHeader}</div>
            <div className="modal__cont">{this.props.body}</div>
            {secondaryBody && <div className="modal__cont">{secondaryBody}</div>}
            <div className="modal__foot">{this.props.buttons}</div>
            {this.props.onAction && <button type="button" className="card_modal__action" onClick={this.props.onAction || this.onCancel}>
              <span className='card_modal__action_label'>{this.props.actionIcon}</span><span>{this.props.actionLabel}</span>
            </button>
            }
          </div>
        </div>
      </>
    )
  }
}

CardModal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  body: PropTypes.node,
  buttons: PropTypes.any,
  onClose: PropTypes.func,
};

export default CardModal;
